import ApiIntegrationGoogleDrive from "../../../../../core/gd/api/integrations/google-drive";

export default function googleDriveConnect() {

    gd.utils.openCenteredWindow(ApiIntegrationGoogleDrive.connectUrl, 'gdrive-connect', 600, 600);

}

